import { Col, Label, Row } from "reactstrap";
import { useLocation } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { RootState } from "../../../../../ReduxToolkit/Store";
import { useSelector } from "react-redux";
import DollarInput from "../../../../common/DollarInput";
import Dropdown from "../../../../common/DropDown";
import { useGetRequestQuery } from "../../../../../Hooks/useGetRequestQuery";
import { getClientFactFindDLLService } from "../../../../../Services/PublicPageServices";
import { H6 } from "../../../../../AbstractElements";
import DecimalInput from "../../../../common/DecimalInput";
import { useMutationRequestQuery } from "../../../../../Hooks/useMutationRequestQuery";
import { getClientMMPIncomeExpenseDetailsByClientId, upsertClientMMPIncomeExpenseDetails } from "../../../../../Services/MMPClientServices/IncomeAndExpenses";
import { toast } from "react-toastify";

export default function FactFindIncomeExpense({ expensesLiving, onMonthlyTotalChange, insertClientIncomeExpenses, incomeExpensesData, clientId }: any) {
    const location = useLocation();
    const isMMPAssetsLiabilitiesRoute = location.pathname === '/MMPAssetsLiabilities';
    const userData = useSelector((state: RootState) => state.auth);
    const [DropdownData, setDropdownData] = useState<any>([]);
    const [formData, setFormData] = useState<any>({});
    const previousFormData = useRef(formData);


    const handleValueChange = (name: string, value: string) => {
        const updatedFormData = {
            ...formData,
            [name]: value,
        };

        if (name.endsWith("-amount") || name.endsWith("-frequency")) {
            const categoryName = name.split("-")[0];
            const amount = updatedFormData[`${categoryName}-amount`] || '0';
            const frequency = updatedFormData[`${categoryName}-frequency`] || '0';

            if (amount && frequency) {
                const { annualAmount, monthlyAmount } = calculateAmounts(categoryName, amount, frequency);
                updatedFormData[`${categoryName}-annual`] = formatNumberWithCommas(annualAmount);
                updatedFormData[`${categoryName}-monthly`] = formatNumberWithCommas(monthlyAmount);
            } else {
                updatedFormData[`${categoryName}-annual`] = '0';
                updatedFormData[`${categoryName}-monthly`] = '0';
            }
        }

        let totalMonthlySum = 0;
        Object.keys(updatedFormData).forEach((key) => {
            if (key.endsWith("-monthly")) {
                const value = updatedFormData[key];
                totalMonthlySum += parseNumber(value);
            }
        });
        setFormData(updatedFormData);
        if (onMonthlyTotalChange) {
            onMonthlyTotalChange(totalMonthlySum);
        }
    };


    const [clientFactFindData] = useState<any>({
        "Renting a Property": [
            "I am Renting A Property"
        ],
        "Child Care & Support": [
            "Child Care & Baby Sitting",
            "Child Maintenance & Support"
        ],
        "Education": [
            "Public School Costs",
            "Private School Costs",
            "Higher Education HECS/HELP"
        ],
        "Groceries": [
            "Food"
        ],
        "House you live in": [
            "Body Corporate",
            "Council Rates (if own property)",
            "Electricity",
            "Gas",
            "Repairs & Maintenance",
            "Sewer Rates",
            "Water usage"
        ],
        "Insurance": [
            "Building Insurance",
            "Contents Insurance",
            "Health Insurance",
            "Income Protection",
            "Life Insurance",
            "Vehicle Insurance"
        ],
        // "Investment Property": [
        //     "Building Insurance",
        //     "Body Corporate",
        //     "Council Rates",
        //     "Land Tax",
        //     "Repairs & Maintenance",
        //     "Running Costs",
        //     "Sewerage Rates"
        // ],
        "Medical Expenses": [
            "Dental & Optical",
            "Medical & Health",
            "Natural Therapists"
        ],
        // "Ongoing Rent": [
        //     "Board",
        //     "Rent"
        // ],
        "Personal Care": [
            "Clothing & Footwear",
            "Cosmetics",
            "Dry Cleaning",
            "Personal Care"
        ],
        "Recreational & Entertainment": [
            "Alcohol & Tobacco",
            "Cinema & Concerts",
            "Dining Out",
            "Gifts & Miscellaneous",
            "Gym & Sports",
            "Pets",
            "Subscriptions (non-streaming)",
            "Takeaway",
            "Travel & Holidays"
        ],
        "Telephone & Internet": [
            "Home & Mobile Phone",
            "Internet",
            "Pay TV & streaming"
        ],
        "Transport": [
            "Petrol",
            "Public Transport",
            "Taxi Ride / Uber",
            "Tolls & Parking",
            "Vehicle Registration",
            "Vehicle Repairs"
        ]
    });

    const {
        data: clientFactFindDLLData,
        isLoading: clientFactFindDataLoading,
        isError: clientFactFindDataIsError,
    } = useGetRequestQuery<any>(
        ['getClientFactFindDLL'],
        getClientFactFindDLLService,
        {
            enabled: true,
        }
    );

    useEffect(() => {
        if (clientFactFindDLLData?.data && !clientFactFindDataIsError && !clientFactFindDataLoading) {
            setDropdownData(clientFactFindDLLData?.data);
        }
    }, [clientFactFindDLLData]);

    const {
        data: clientMMPIncomeExpenseDetailsResponse,
        isLoading: isClientMMPIncomeExpenseDetailsLoading,
        isError: isClientMMPIncomeExpenseDetailsError,
        refetch
    } = useGetRequestQuery<any>(
        ['getClientMMPIncomeExpenseDetailsByClientId', clientId],
        () => getClientMMPIncomeExpenseDetailsByClientId(clientId as string),
        {
            enabled: !!clientId,
        }
    );

    const transformResponseToFormData = (responseData: any[]) => {
        const transformedData: any = {};

        responseData.forEach((expense) => {
            const { expenseId, categoryName, amountValue, frequencyValue, annualAmountValue, monthlyAmountValue, percentageOfTotalValue } = expense;

            // Map each field to the formData structure
            transformedData[`${categoryName}-expenseId`] = expenseId; // Include expenseId
            transformedData[`${categoryName}-amount`] = amountValue;
            transformedData[`${categoryName}-frequency`] = frequencyValue;
            transformedData[`${categoryName}-annual`] = annualAmountValue;
            transformedData[`${categoryName}-monthly`] = monthlyAmountValue;
            transformedData[`${categoryName}-percentage`] = percentageOfTotalValue;
        });

        return transformedData;
    };

    // Update form data when the response is received
    useEffect(() => {
        if (
            clientMMPIncomeExpenseDetailsResponse?.data &&
            !isClientMMPIncomeExpenseDetailsError &&
            !isClientMMPIncomeExpenseDetailsLoading
        ) {
            const transformedData = transformResponseToFormData(clientMMPIncomeExpenseDetailsResponse.data);
            setFormData(transformedData);
        }
    }, [clientMMPIncomeExpenseDetailsResponse, isClientMMPIncomeExpenseDetailsError, isClientMMPIncomeExpenseDetailsLoading]);

    // Function to split the dropdown values into an array
    const splitDropdownValues = (dropdownValues: string) => {
        return dropdownValues ? dropdownValues.split(',').map(value => value.trim()) : [];
    };

    const prepareDataForApi = () => {
        const dataForApi = [] as any;

        Object.keys(clientFactFindData).forEach((parentCategory) => {
            clientFactFindData[parentCategory].forEach((categoryName: string) => {
                const formKey = `${categoryName}-amount`;

                if (formData[formKey] !== undefined) {
                    const expense = {
                        // expenseId: formData[`${categoryName}-expenseId`] || 0,
                        clientId: clientId,
                        parentCategory,
                        categoryName,
                        amountValue: formData[`${categoryName}-amount`] || '0',
                        frequencyValue: formData[`${categoryName}-frequency`] || '0',
                        annualAmountValue: formData[`${categoryName}-annual`] || '0',
                        monthlyAmountValue: formData[`${categoryName}-monthly`] || '0',
                        percentageOfTotalValue: formData[`${categoryName}-percentage`] || '0'
                    };
                    dataForApi.push(expense);
                }
            });
        });

        return dataForApi;
    };

    const { mutate: upsertClientIncomeExpenses, isPending: isUpsertClientIncomeExpensesPending } = useMutationRequestQuery(
        'upsertClientIncomeExpenses',
        upsertClientMMPIncomeExpenseDetails,
        {
            onSuccess: (data: any) => {
                refetch()
            },
            onError: (error: any) => {
                toast.error('Failed to save information');
            },
        }
    );

    const handleSubmit = () => {
        const apiData = prepareDataForApi();
        upsertClientIncomeExpenses(apiData);
    }


    const parseNumber = (value: string | undefined | null) => {
        if (value == null || value.trim() === '') return 0;
        return parseFloat(value.replace(/,/g, '') || '0');
    };
    const formatNumberWithCommas = (value: number) => {
        return value.toLocaleString('en-US').toString();
    };



    const calculateAmounts = useCallback((categoryName: string, amount: string, frequency: string) => {
        let annualAmount = 0;
        let monthlyAmount = 0;
        const parsedAmount = parseNumber(amount);  // Ensure this function correctly handles commas

        switch (frequency) {
            case 'Per week':
                annualAmount = parsedAmount * 52;
                break;
            case 'Per fortnight':
                annualAmount = parsedAmount * 26;
                break;
            case 'Per month':
                annualAmount = parsedAmount * 12;
                break;
            case 'Per quarter':
                annualAmount = parsedAmount * 4;
                break;
            case 'Per half year':
                annualAmount = parsedAmount * 2;
                break;
            case 'Per year':
                annualAmount = parsedAmount;
                break;
            default:
                break;
        }

        monthlyAmount = annualAmount / 12;

        return { annualAmount, monthlyAmount };
    }, []);

    // Effect to update form data when amount or frequency changes
    useEffect(() => {
        const updatedFormData = { ...formData };
        let totalMonthlySum = 0;

        Object.keys(formData).forEach((key) => {
            if (key.includes("-amount") || key.includes("-frequency")) {
                const lastIndex = key.lastIndexOf("-");
                const categoryName = key.substring(0, lastIndex); // FIX: Handles categories with hyphens

                const amount = formData[`${categoryName}-amount`] || '';
                const frequency = formData[`${categoryName}-frequency`] || '';

                if (amount && frequency) {
                    const { annualAmount, monthlyAmount } = calculateAmounts(categoryName, amount, frequency);
                    const roundedMonthlyAmount = Math.round(monthlyAmount);

                    updatedFormData[`${categoryName}-annual`] = formatNumberWithCommas(annualAmount);
                    updatedFormData[`${categoryName}-monthly`] = formatNumberWithCommas(roundedMonthlyAmount);
                } else {
                    updatedFormData[`${categoryName}-annual`] = '0';
                    updatedFormData[`${categoryName}-monthly`] = '0';
                }

                // Calculate percentage using monthly value instead of amount
                const monthlyValue = parseNumber(updatedFormData[`${categoryName}-monthly`]);
                const expensesLivingValue = parseNumber(expensesLiving);

                let percentage = 0;
                if (!isNaN(expensesLivingValue) && expensesLivingValue !== 0) {
                    percentage = (monthlyValue / expensesLivingValue) * 100;
                }
                updatedFormData[`${categoryName}-percentage`] = percentage.toFixed(0);
            }
        });

        // Calculate total of all monthly fields
        Object.keys(updatedFormData).forEach((key) => {
            if (key.endsWith("-monthly")) {
                totalMonthlySum += parseNumber(updatedFormData[key]);
            }
        });

        if (onMonthlyTotalChange) {
            onMonthlyTotalChange(totalMonthlySum);
        }

        if (JSON.stringify(previousFormData.current) !== JSON.stringify(updatedFormData)) {
            previousFormData.current = updatedFormData;
            setFormData(updatedFormData);
        }
    }, [formData, calculateAmounts, expensesLiving]);


    return (
        <div className={isMMPAssetsLiabilitiesRoute ? 'mmp-assets-liabilities container-fluid' : 'container-fluid'} onBlur={handleSubmit}>
            <div className="table-responsive h-100 py-4">
                <section className='bg-white'>
                    <div className="scrollable-table-container">
                        <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                            <Row>
                                {/* Heading Row */}
                                <div className='d-flex'>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '20%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Expense</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Amount</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Frequency</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Annual</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">Monthly</Label>
                                    </Col>
                                    <Col className="responsive-col-expense" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        <Label className="heading-color f-w-900 text-left">% OF Expense</Label>
                                    </Col>
                                </div>
                                <div className="container-fluid">
                                    {Object.keys(clientFactFindData).map((parentCategory) => {
                                        return (
                                            <div key={parentCategory}>
                                                <div className="d-flex align-items-center mt-4 mb-2">
                                                    <Col xs={12} className='d-flex'>
                                                        <H6 className="heading-color f-w-900 text-left">{parentCategory !== "Renting a Property" && parentCategory}</H6>
                                                    </Col>
                                                </div>
                                                {clientFactFindData[parentCategory].map((categoryName: string, index: number) => {
                                                    return (
                                                        <div key={index} className='d-flex item-center'>
                                                            <Col className="responsive-col-expense" xs={12} style={{ width: '20%' }}>
                                                                <Label
                                                                    style={{ color: categoryName === "I am Renting A Property" ? 'blue' : '' }}
                                                                    className="mb-3"
                                                                >
                                                                    {categoryName}
                                                                </Label>
                                                            </Col>
                                                            <Col className="responsive-col-expense" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                                                <DollarInput
                                                                    label=""
                                                                    name={`${categoryName}-amount`}
                                                                    value={formData[`${categoryName}-amount`]}
                                                                    setValue={(name, value) => handleValueChange(`${categoryName}-amount`, value)}
                                                                    placeholder=""
                                                                    design="flex"
                                                                    limit={6}
                                                                />
                                                            </Col>
                                                            <Col className="responsive-col-expense" xs={12} style={{ width: '9%', paddingInline: '2px' }}>
                                                                <Dropdown
                                                                    label=""
                                                                    name={`${categoryName}-frequency`}
                                                                    value={formData[`${categoryName}-frequency`] || ''}
                                                                    options={splitDropdownValues(DropdownData ? DropdownData[11]?.dropDownValues : '')}
                                                                    setValue={(name, value) => handleValueChange(`${categoryName}-frequency`, value)}
                                                                />
                                                            </Col>
                                                            <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                                                <DollarInput
                                                                    label=""
                                                                    name={`${categoryName}-annual`}
                                                                    value={formData[`${categoryName}-annual`] || '0'}
                                                                    setValue={(name, value) => handleValueChange(`${categoryName}-annual`, value)}
                                                                    placeholder=""
                                                                    design="flex"
                                                                    disabled
                                                                    limit={8}
                                                                />
                                                            </Col>
                                                            <Col className="responsive-col-expense" xs={12} style={{ width: '10%', paddingInline: '2px' }}>
                                                                <DollarInput
                                                                    label=""
                                                                    name={`${categoryName}-monthly`}
                                                                    value={formData[`${categoryName}-monthly`] || '0'}
                                                                    setValue={(name, value) => handleValueChange(`${categoryName}-monthly`, value)}
                                                                    placeholder=""
                                                                    disabled
                                                                    limit={8}
                                                                />
                                                            </Col>
                                                            <Col className="responsive-col-expense" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                                                <DecimalInput
                                                                    label=""
                                                                    name={`${categoryName}-percentage`}
                                                                    value={formData[`${categoryName}-percentage`] || '0'}
                                                                    setValue={(name, value) => handleValueChange(`${categoryName}-percentage`, value)}
                                                                    placeholder=""
                                                                    disabled
                                                                    limit={4}
                                                                />
                                                            </Col>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })}
                                </div>
                            </Row>
                        </table>
                    </div>
                </section>
            </div>
        </div>
    );
}
